import { render, staticRenderFns } from "./AccountLimitBody.vue?vue&type=template&id=224bce6d&scoped=true&"
import script from "./AccountLimitBody.vue?vue&type=script&lang=js&"
export * from "./AccountLimitBody.vue?vue&type=script&lang=js&"
import style0 from "./AccountLimitBody.vue?vue&type=style&index=0&id=224bce6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224bce6d",
  null
  
)

export default component.exports